import { Input, Checkbox, Tooltip, Info } from '@weareopenr/component-library';
import { UseFormRegister, Control, FieldErrors } from 'react-hook-form';

import { IFormValues } from 'src/components/VenueDetailsEditModal/types';
import styles from './VenueDetailsFields.module.scss';

interface IVenueDetailsFields {
  register: UseFormRegister<IFormValues>;
  control: Control<IFormValues>;
  errors: FieldErrors<IFormValues>;
}

const VenueDetailsFields = ({ register, errors }: IVenueDetailsFields) => {
  return (
    <div className={styles['venue-details']}>
      <div className={styles['venue-inputs']}>
        <Input
          type="text"
          label="Name"
          register={register('name', { required: 'Please enter a name' })}
          error={errors?.name?.message}
        />
      </div>
      <div className={styles['is-trial-venue']}>
        <Checkbox label="Trial venue" name="isTrial" register={register} labelWeight="regular" />
        <Tooltip text="A venue that is used for testing purposes only">
          <Info />
        </Tooltip>
      </div>
    </div>
  );
};

export default VenueDetailsFields;
